import React from 'react'
import { observer } from 'mobx-react'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import FormFieldset from 'components/UI/AsideModal/Form/FormFieldset'
import asideModalStore from 'Stores/asideModalStore'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'
import useLocalization from 'hooks/useLocalization'

const AddingFunnelsModal = () => {
  const {
    modalValues: modalValue,
    changeValue: changeValues,
    check,
  } = asideModalStore

  const { translate } = useLocalization({
    section: 'crm',
    subsection: 'crm_settings',
    dict: {
      add_contact: 'Add contact',
      name: 'Name',
      add_funnels: 'Add funnels',
      funnel_name: 'Funnel name',
      add_field: 'Add a field',
      field_name: 'Field name',
      field_type: 'Field type',
      boolean: 'Boolean',
      text: 'Text',
      access: 'Access',
    },
  })

  const handleSelectChange = (selectedOptions) => {
    const selectedValues = Array.isArray(selectedOptions)
      ? selectedOptions.map((option) => option.id)
      : selectedOptions
        ? [selectedOptions.id]
        : []

    changeValues(selectedValues, 'employees')
  }

  const handleInputChange = (e) => {
    changeValues(e.target.value, 'name')
  }

  return (
    <FormFieldset>
      <FormField>
        <FormLabel isRequired>{translate.funnel_name}:</FormLabel>
        <FormInput isError={check('name')}>
          <input
            placeholder={translate.funnel_name}
            type='text'
            value={modalValue?.name || ''}
            onChange={handleInputChange}
            maxLength={50}
          />
        </FormInput>
      </FormField>

      <FormField>
        <FormLabel>{translate.access}:</FormLabel>
        <SelectCustom
          optionLabelKey={'full_name'}
          placeholder={translate.access}
          valueID={modalValue?.employees || []}
          onChange={handleSelectChange}
          apiLinkCRM={'integration/employees'}
          error={check('employees')}
          isMulti
        />
      </FormField>
    </FormFieldset>
  )
}

export default observer(AddingFunnelsModal)
